import React, { useContext, useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { getAffiliate } from 'PublicAPI';

import { ConfigContext } from 'Context/config';

import { Content } from 'LegacySBCRA/Content/Content';
import { LogoAffiliate } from 'Storybook/components/local/LogoAffiliate/LogoAffiliate';

import TrustpilotReviewsCarousel from '../../../../components/reviews/ReviewsCarousel/TrustpilotReviewsCarousel';
import { stepsConfig, stepsTitle } from '../../../../components/steps/config/howToConfig';
import StepsSection from '../../../../components/steps/StepsSection';
import DialogLoader from '../../../../components/transitions/DialogLoader/DialogLoader';
import { RoundedSection } from '../../common/RoundedSection/RoundedSection';
import Status404 from '../../error/404';
import BrandingContent from '../../fastlane/branding/BrandingContent';
import DealerLogos from '../../fastlane/dealerLogos/DealerLogos';
import USP from '../../fastlane/home/Usp/Usp';
import RecentSales from '../../fastlane/recentSales/RecentSales';

import Hero from './Hero/Hero';
import LocalTexts from './AffiliatePageTexts.json';

import styles from './AffiliatePage.scss';

const LocalT = new MDText(LocalTexts);

const AffiliatePage = () => {
  const { configState: { affiliate: staticAffiliate } } = useContext(ConfigContext);
  const { params: { partner } } = useRouteMatch();

  const [affiliate, setAffiliate] = useState(staticAffiliate);
  const [loading, setLoading] = useState(!staticAffiliate);
  const [failedReviewsCarousel, setFailedReviewsCarousel] = useState(false);

  useEffect(() => {
    if (!affiliate) {
      const fetchAffiliate = async () => {
        const { affiliate: newAffiliate } = await getAffiliate(partner)
          .catch((err) => {
            window?.Sentry?.captureException(new Error(err));

            return { affiliate: null };
          });

        setAffiliate(newAffiliate);
        setLoading(false);
      };

      fetchAffiliate();
    }
  }, [affiliate, partner]);

  if (loading) {
    return (<DialogLoader />);
  }

  if (!affiliate) {
    return (<Status404 />);
  }

  return (
    <>
      <Hero affiliate={affiliate?.slug} />
      <div className={styles.strippedWrapper}>
        <USP className={styles.usp}>
          <div className={cx(styles.uspWrapper, { [styles[affiliate.slug]]: affiliate?.slug })}>
            <LogoAffiliate affiliate={affiliate?.slug} className={styles.logo} />
            <h2 className={styles.title}>
              {LocalT.translate('titleUSP')}
            </h2>
          </div>
        </USP>
        <RecentSales carouselClassName={styles.recentSales} className={styles.recentSalesWrapper} theme="off-white" />
        <RoundedSection withBottomLedge withTopLedge>
          <StepsSection
            isAffiliate
            config={stepsConfig()}
            stepsClassName={styles.steps}
            title={stepsTitle}
          />
        </RoundedSection>

        <RoundedSection withBottomLedge withTopLedge theme="off-white">
          <Content element="section" wrapper={{ className: failedReviewsCarousel ? styles.trustpilotEmpty : styles.trustpilot }}>
            <TrustpilotReviewsCarousel
              largeTitle
              failedLoad={failedReviewsCarousel}
              setFailedLoad={setFailedReviewsCarousel}
            />
          </Content>
        </RoundedSection>

        <RoundedSection withBottomLedge withTopLedge>
          <DealerLogos className={styles.dealerLogos} />
        </RoundedSection>
        <RoundedSection withBottomLedge withTopLedge theme="off-white">
          <BrandingContent />
        </RoundedSection>

      </div>
    </>
  );
};

export default AffiliatePage;
